import CustomerLogoWrapper from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogoWrapper';
import {CustomerLogoRenderProps} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogo';

export const CustomerLogoSlack = ({
  colorWay,
  contextId,
  ...props
}: Omit<CustomerLogoRenderProps, 'logoViewboxAlignments' | 'title'>) => {
  return (
    <CustomerLogoWrapper
      xmlns="http://www.w3.org/2000/svg"
      logoViewboxAlignments={{
        left: 47.15,
        right: -47.19,
        top: 7.12,
        bottom: -6.170000000000002,
      }}
      title="Slack"
      {...props}
    >
      <g fill="none">
        <path
          fill="var(--userLogoColor, #000)"
          d="M80.95 28.15l1.32-3.06a8.8 8.8 0 005.2 1.62c1.38 0 2.25-.53 2.25-1.34-.02-2.26-8.28-.49-8.34-6.15-.03-2.87 2.53-5.08 6.15-5.08 2.15 0 4.3.53 5.83 1.75L92.12 19a9.32 9.32 0 00-4.8-1.53c-1.13 0-1.88.53-1.88 1.21.02 2.21 8.34 1 8.43 6.4 0 2.94-2.49 5-6.07 5-2.61 0-5.02-.62-6.85-1.94M131.59 24a3.8 3.8 0 110-3.74l3.64-2.02a7.98 7.98 0 100 7.78L131.59 24zM95.7 7.53h4.55v22.26H95.7zm41.31 0V29.8h4.56v-6.68l5.4 6.68h5.84l-6.88-7.93 6.37-7.4h-5.58l-5.15 6.15V7.53zm-23.21 16.5a4.2 4.2 0 01-3.56 1.9 3.8 3.8 0 110-7.62c1.53 0 2.9.85 3.55 1.96v3.76zm0-9.57v1.8c-.75-1.25-2.6-2.12-4.54-2.12-4 0-7.15 3.53-7.15 7.95 0 4.43 3.15 8 7.15 8 1.94 0 3.79-.87 4.53-2.13v1.8h4.56v-15.3h-4.56z"
        />
        <path
          fill="var(--userLogoColor, #E01E5A)"
          d="M52.79 24a2.8 2.8 0 11-2.81-2.8h2.81V24zm1.4 0a2.8 2.8 0 115.62 0v7.02a2.8 2.8 0 11-5.62 0v-7.01z"
        />
        <path
          fill="var(--userLogoColor, #36C5F0)"
          d="M57 12.74a2.8 2.8 0 112.81-2.8v2.8h-2.8zm0 1.42a2.8 2.8 0 110 5.62h-7.04a2.8 2.8 0 110-5.62H57z"
        />
        <path
          fill="var(--userLogoColor, #2EB67D)"
          d="M68.26 16.97a2.8 2.8 0 112.81 2.8h-2.8v-2.8zm-1.4 0a2.8 2.8 0 11-5.62 0V9.93a2.8 2.8 0 115.62 0v7.04z"
        />
        <path
          fill="var(--userLogoColor, #ECB22E)"
          d="M64.05 28.22a2.8 2.8 0 11-2.81 2.8v-2.8h2.8zm0-1.4a2.8 2.8 0 110-5.62h7.04a2.8 2.8 0 110 5.61h-7.04z"
        />
      </g>
    </CustomerLogoWrapper>
  );
};
